import axios from "axios";

const ENV_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

// When the app is loaded on a domain different from REACT_APP_BACKEND_URL (e.g. a custom
// production domain like gabservices.site), call the API on the SAME origin to avoid
// cross-origin + credentials CORS issues. K8s ingress routes /api to the backend on every domain.
function pickBackend() {
    if (typeof window === "undefined") return ENV_URL;
    const currentOrigin = window.location.origin;
    if (!ENV_URL) return currentOrigin;
    try {
        const envHost = new URL(ENV_URL).host;
        if (envHost !== window.location.host) {
            return currentOrigin;
        }
    } catch {
        return currentOrigin;
    }
    return ENV_URL;
}

const BACKEND_URL = pickBackend();
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
});

// Attach bearer token if present (fallback when cookies are blocked)
api.interceptors.request.use((config) => {
    try {
        const token = localStorage.getItem("gabs_token");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
    } catch {
        /* noop */
    }
    return config;
});

export function formatPrice(value, currency = "FCFA") {
    if (value == null) return "";
    return `${Number(value).toLocaleString("fr-FR")} ${currency}`;
}

export function formatApiError(err) {
    const detail = err?.response?.data?.detail;
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
    return err?.message || "Une erreur est survenue";
}
